import { ChatMessageListItem, IChatConversation } from 'src/@types/chat';
import { P2PInitialState } from 'src/sections/@dashboard/chat/ChatConversation/ChatInitialState/P2PInitialState';
import { TextInitialState } from 'src/sections/@dashboard/chat/ChatConversation/ChatInitialState/TextInitialState';
import { ThreadFirstMessage } from 'src/sections/@dashboard/chat/ChatConversation/ChatInitialState/ThreadFirstMessage';

type Props = {
  conversation: IChatConversation;
  messages?: ChatMessageListItem[];
};

export const ChatInitialState = ({ conversation, messages }: Props) => {
  if (!conversation._id) return null;

  if (conversation.p2p) {
    return <P2PInitialState conversation={conversation} />;
  }

  if (conversation.parentId) {
    return (
      <ThreadFirstMessage conversation={conversation} messages={messages} />
    );
  }

  return <TextInitialState conversation={conversation} />;
};
